import { Component, Input, OnInit, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';

import * as  Objects from '@core/objects';

import { VersionFeedback } from '@core/models/version-feedback';
import { VersionShare, ApprovalStatusCodeEnum, VersionShareStatus } from '@core/models/version-share.model';

@Component({
    selector: 'core-versions-approval-box',
    templateUrl: './approval-box.component.html',
    styleUrls: ['./approval-box.component.scss']
})
export class VersionsApprovalBoxComponent implements OnInit, OnChanges {
    public readonly APPROVAL_STATUS = ApprovalStatusCodeEnum;
    @Input() version: Objects.Version;
    @Input() feedback: VersionFeedback;
    @Input() versionShare: VersionShare;

    @Output() actionApprove = new EventEmitter<any>();
    @Output() actionReject = new EventEmitter<any>();

    public feedbackStatus: VersionShareStatus;
    public satusDate: string;
    
    constructor( ) { }

    ngOnInit() {
        this.setApprovalStatus();
       
    }
    ngOnChanges(changes: SimpleChanges): void {
        if(changes.feedback || changes.versionShare){
            this.setApprovalStatus();
        }
    }

    onApprove(event: any){
        this.actionApprove.emit(event);
    }

    onReject(event: any){
        this.actionReject.emit(event);
    }

    private setApprovalStatus() : void {
        if(this.feedback != null){
            this.feedbackStatus = this.feedback.approval;
            // fix 2024/08/08 <rafael@twonas.com> date from approval
            // this.satusDate = this.feedback.status.date;
            this.satusDate = this.feedback.approval.date;
        }
        if(this.versionShare!= null){
            this.feedbackStatus = this.versionShare.status;
            this.satusDate = this.versionShare.status.date;
        }
    }

}
